export default __webpack_public_path__ + "static/media/rojon.26b7d3d1.jpg";